'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-switch-button',
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnCheckbox = "".concat(CLASSNAME, "__checkbox"),
    cnContentCheckbox = "".concat(CLASSNAME, "__content-checkbox"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnWide = 'wide';
/**
 * 
 */

function SwitchButton(_ref) {
  var className = _ref.className,
      defaultSelected = _ref.defaultSelected,
      items = _ref.items,
      name = _ref.name,
      _onChange = _ref.onChange,
      selected = _ref.selected,
      wide = _ref.wide;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, items.map(function (_ref2, i) {
    var title = _ref2.title,
        value = _ref2.value;
    return /*#__PURE__*/React__default.createElement("label", {
      className: cnLabel,
      key: i
    }, /*#__PURE__*/React__default.createElement("input", {
      checked: typeof selected !== 'undefined' ? selected === value : undefined,
      defaultChecked: typeof defaultSelected !== 'undefined' ? defaultSelected === value : undefined,
      type: "radio",
      name: name,
      className: cnCheckbox,
      onChange: function onChange(e) {
        _onChange(value, e.target.checked);
      },
      value: value
    }), /*#__PURE__*/React__default.createElement("div", {
      className: classNames(cnContentCheckbox, _rollupPluginBabelHelpers.defineProperty({}, cnWide, wide))
    }, /*#__PURE__*/React__default.createElement("span", {
      className: cnTitle
    }, title), /*#__PURE__*/React__default.createElement(MaterialDrop, null)));
  }));
}
SwitchButton.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Default selected value */
  defaultSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /** Array of items */
  items: PropTypes.array.isRequired,

  /** Name in form */
  name: PropTypes.string,

  /** Callback function */
  onChange: PropTypes.func.isRequired,

  /** Selected value */
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /** True for wide styling */
  wide: PropTypes.bool
};
SwitchButton.defaultProps = {
  onChange: function onChange() {
    return void 0;
  }
};

module.exports = SwitchButton;
